<template>
  <div>
    <section class="hero hero-lp hero-blackfriday">
      <div class="hero-body">
        <div class="container">
          <!-- <div class="columns pt-5 pb-5" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-7-tablet is-6-desktop has-text-centered-mobile titlearea">
              <h1 class="title has-background-secondary has-text-white is-inline-block is-size-6 is-size-5-tablet has-text-weight-bold is-uppercase u-pl15 u-pr15 u-p05 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="subtitle has-text-white is-size-4 is-size-3-tablet has-text-weight-bold">
                Beim Urlaub 2021 nicht schwarz malen, sondern gelb sehen.
              </h2>
 
            </div>
            <div class="column has-text-centered">
              <img importance="high" :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/black-friday.jpg`" alt="Black Friday Week" width="400" height="300" />
            </div>
          </div> -->

          <div class="columns pt-5 pb-5 is-vcentered is-variable is-1" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-6-tablet is-5-desktop has-text-centered-mobile titlearea">
              <h1 class="title has-background-secondary is-inline-block is-size-4 is-size-3-tablet is-size-2-desktop has-text-weight-bold has-text-white pr-1 pl-1 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="title blackfriday-title is-size-2 is-size-1-desktop has-text-weight-bold has-text-white is-size-1-tablet ">
                <p>Black Week</p>
                <p style="line-height: 0.5">22. - 28.11.2021</p>
              </h2>
              <!-- <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p> -->
            </div>
            <div class="column has-text-centered">
              <img importance="high" :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/black-friday.png`" alt="Black Friday" width="781" height="326" />
            </div>
          </div>

          <div class="columns" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
            <div class="column is-7-tablet is-7-desktop has-text-centered-mobile titlearea">
              <h1 class="title has-background-white has-text-black is-inline-block is-size-5 is-size-4-tablet is-size-3-desktop has-text-weight-bold is-uppercase u-pl15 u-pr15 u-p05">
                Black Friday Week
              </h1>
              <h2 class="subtitle has-text-white">
                21. November – 29.November
              </h2>
              <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p>
            </div>
            <div class="column has-text-centered">
              <img
                importance="high"
                :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png`"
                :srcset="
                  `https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 500w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=370&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 370w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=280&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 280w`
                "
                sizes="(max-width: 500px) 100vw, 400px"
                alt="Black Friday Week"
                width="400"
                height="300"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile advantages-lp">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>

    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <h2 class="title">Black Week Deals</h2>
            <h3 class="subtitle has-text-weight-bold">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</h3>
            <div class="content">
              <p>
                Kaufen, sparen und freuen! Das ist das Motto unserer diesjährigen Black Week vom 22. bis 28. November. Mit dem ADAC Hotelgutschein sichern Sie sich Vorfreude auf einen Aufenthalt in einem exklusiven Hotel Ihrer Wahl. Freuen Sie sich auf ausgesuchte Angebote für Ihren Kurzurlaub in
                Deutschland, Österreich oder Italien, die wir nochmals für Sie reduziert haben.
              </p>

              <p>Perfekt auch als Geschenk für Weihnachten – oder einfach, weil Sie es sich verdient haben! Für flexibles und sicheres Reisen, <span class="is-inline-block">3 Jahre gültig</span> und übertragbar.</p>
            </div>
          </div>

          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
            <h2 class="title">Jetzt schon an Weihnachten denken</h2>
            <div class="content">
              <p>
                Ab 21. November 2020 ist es soweit: Wir starten in die <strong>Black Friday Woche!</strong> Sparen Sie bis zum 29.11. nochmals auf unsere bereits deutliche reduzierten Hotelgutscheine. Lassen Sie sich diese Chance nicht entgehen und sichern Sie sich einen Urlaubsgutschein für Ihren
                nächsten Kurzurlaub oder kaufen Sie bereits jetzt ein Weihnachtsgeschenk für Ihre Liebsten. Unsere Black Friday Angebote finden Sie hier.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers">
      <div class="container">
        <div v-if="offers.length == 0" v-observe-visibility="contentVisibilityChanged">
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold">
                <b-icon icon="sad-cry" size="is-large"></b-icon>
                <br />Leider sind keine Angebote vorhanden!
              </div>
            </div>
          </div>

          <OfferBlock :title="$t('general.further-offers')" :offers="furtherOffers" v-if="isContentVisible" />

          <h3 class="title is-size-3 has-text-centered is-size-4-mobile">{{ $t('general.themes') }}</h3>
          <div class="columns is-centered">
            <div class="column is-10-desktop is-8-widescreen">
              <div class="buttons is-justify-content-center">
                <b-button
                  tag="router-link"
                  v-for="item in menu.themes"
                  :key="item.key"
                  :to="{
                    name: 'search-by-theme',
                    params: {
                      id: item.key,
                      name: $options.filters.removeSpecialChars(item.value),
                    },
                  }"
                  type="is-dark"
                >
                  {{ item.value }}
                </b-button>
              </div>
            </div>
          </div>

          <p class="has-text-centered has-text-weight-bold mt-5">Viele weitere Urlaubsgutscheine warten hier auf Sie!</p>
          <div class="has-text-centered mt-3">
            <b-button tag="router-link" to="/" type="is-dark">
              Zu allen Angeboten
            </b-button>
          </div>
        </div>

        <div v-if="offers.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:blackfriday -->

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--blackfriday" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/modules/hoteldisplay/_store'
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'

const OfferBlock = () => import(/* webpackPrefetch: true , webpackChunkName: "offerblock" */ '@/components/OfferBlock')

export default {
  name: 'blackfriday',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
    OfferBlock,
  },
  data() {
    return {
      offers: [],
      isContentVisible: false,
    }
  },
  computed: {
    ...mapGetters({
      furtherOffers: '$_hotel/furtherOffers',
      menu: 'menu',
    }),
    campaignTimer: function() {
      let endDate = new Date('2021-11-29') - new Date()
      return endDate
    },
  },
  created() {
    const STORE_KEY = '$_hotel'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  async mounted() {
    const offers = await OfferApi.getOffersWithCustomPromotion('blackweek21')
    this.offers = offers.sort((a, b) => b.rating - a.rating)

    this.$store.dispatch('$_hotel/getFurtherOffers')
  },
  methods: {
    contentVisibilityChanged(isVisible) {
      if (isVisible) {
        this.isContentVisible = true
      }
    },
  },
  metaInfo() {
    return {
      title: 'Blackfriday',
      meta: [{name: 'description', content: 'Black Friday Week - Ausgewählte Kurzurlaube nochmals deutlich reduziert!'}],
      link: [{rel: 'preconnect', href: '//maps.googleapis.com', crossorigin: 'anonymous'}],
    }
  },
}
</script>

<style lang="scss">
.hero-blackfriday {
  background-color: #000;
}

.offer--blackfriday {
  .card-tag .tag {
    background-color: #000 !important;
  }
}

@media screen and (min-width: 1418px) {
  .blackfriday-title {
    font-size: 4rem !important;
  }
}
</style>
